function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

import urlPluginMessage from './templates/urlPluginMessage';

var _callback = /*#__PURE__*/_classPrivateFieldLooseKey("callback");

var _urlPluginAppendMessage = /*#__PURE__*/_classPrivateFieldLooseKey("urlPluginAppendMessage");

var UiMutator = /*#__PURE__*/function () {
  function UiMutator(_ref) {
    var observeEl = _ref.el,
        config = _ref.config;

    _classCallCheck(this, UiMutator);

    Object.defineProperty(this, _urlPluginAppendMessage, {
      value: _urlPluginAppendMessage2
    });
    Object.defineProperty(this, _callback, {
      value: _callback2
    });
    this.observeEl = observeEl;
    this.config = config;
    this.observer = new MutationObserver(_classPrivateFieldLooseBase(this, _callback)[_callback].bind(this));
  }

  _createClass(UiMutator, [{
    key: "observe",
    value: function observe() {
      this.observer.observe(this.observeEl, {
        attributes: false,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.observer.disconnect();
    }
  }]);

  return UiMutator;
}();

function _callback2(mutationList) {
  var _this = this;

  mutationList.forEach(function (_ref2) {
    var type = _ref2.type,
        addedNodes = _ref2.addedNodes;
    if (type !== 'childList') return;
    addedNodes.forEach(function (el) {
      _classPrivateFieldLooseBase(_this, _urlPluginAppendMessage)[_urlPluginAppendMessage](el);
    });
  });
}

function _urlPluginAppendMessage2(el) {
  if (!(el instanceof Element)) return;
  var targetEl = el.querySelector('.uppy-Url');
  if (!targetEl) return;
  targetEl.appendChild(urlPluginMessage({
    maxSize: this.config.maxSize
  }));
}

export default UiMutator;